import { readOnlyDateFormat } from "./DateFormats";

export function readOnlyMessage(endDate: Date, reason: string) {
	return `You are in read only until ${readOnlyDateFormat(endDate)}.\nReason: ${reason}`;
}
export function suspendedMessage(endDate: Date, reason: string) {
	return `You are suspended till ${readOnlyDateFormat(endDate)} because of ${reason} and can’t upload any content`;
}
